import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AdminLayout from "./AdminLayout";
import PrivateRoute from "./PrivateRoute";
import constants from "../common/constants";

const Dashboard = LazyLoad(lazy(() => import("../pages/dashboard")));
const Venues = LazyLoad(lazy(() => import("../pages/venues")));
const AddVenues = LazyLoad(lazy(() => import("../pages/venues/addVenues")));
const Vendors = LazyLoad(lazy(() => import("../pages/vendors")));
const AddVendors = LazyLoad(lazy(() => import("../pages/vendors/addVendors")));
const SuitableVenues = LazyLoad(lazy(() => import('../pages/tools/suitableVenues')));
const Transportation = LazyLoad(lazy(() => import("../pages/tools/Transportation")));
const VendorPlanning = LazyLoad(lazy(() => import("../pages/tools/vendorPlanning")));
const CompareVenues = LazyLoad(lazy(() => import("../pages/tools/compareVenues")));
const HospitalityAndManagement = LazyLoad(lazy(() => import("../pages/tools/hospitalityAndManagement")));
const UserProfile = LazyLoad(lazy(() => import("../pages/user-profile")));
const VenuePlanning = LazyLoad(lazy(() => import("../pages/tools/venuePlanning")));
const CRM = LazyLoad(lazy(() => import("../pages/crm/index"))); // Ensure this path is correct
const AddCRM = LazyLoad(lazy(() => import("../pages/crm/addCRM")));
const CRMNEW = LazyLoad(lazy(() => import("../pages/crm-new/index")));
const AddLeads = LazyLoad(lazy(() => import("../pages/crm-new/addLeads")));
const Estimates = LazyLoad(lazy(() => import("../pages/estimates/index")));
const AddEstimate = LazyLoad(lazy(() => import("../pages/estimates/addEstimate")));
const Attendees = LazyLoad(lazy(() => import("../pages/attendees")));
const AddAttendee = LazyLoad(lazy(() => import("../pages/attendees/addAttendee")));
// const UserOnly = LazyLoad(lazy(() => import("../pages/user")));
const { ADMIN, USER } = constants;

const AdminRoutes = {
  path: "/app",
  element: <AdminLayout />,
  children: [
    {
      path: "/app",
      element: (
        <PrivateRoute element={<Dashboard />} requiredRole={[ADMIN, USER]} />
      ),
    },
    {
      path: "/app/vendors",
      element: (
        <PrivateRoute element={<Vendors />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/add-vendors",
      element: (
        <PrivateRoute element={<AddVendors />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/venues",
      element: <PrivateRoute element={<Venues />} requiredRole={[ADMIN]} />,
    },
    {
      path: "/app/add-venues",
      element: <PrivateRoute element={<AddVenues />} requiredRole={[ADMIN]} />,
    },
    {
      path: "/app/tools",
      element: (
        <PrivateRoute element={<Dashboard />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/transportation",
      element: (
        <PrivateRoute element={<Transportation />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/suitable-venues",
      element: (
        <PrivateRoute element={<SuitableVenues />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/vendor-planning",
      element: (
        <PrivateRoute element={<VendorPlanning />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/compare-venues",
      element: (
        <PrivateRoute element={<CompareVenues />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/hospitality-management",
      element: (
        <PrivateRoute element={<HospitalityAndManagement />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/user-profile",
      element: (
        <PrivateRoute element={<UserProfile />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/venue-planning",
      element: (
        <PrivateRoute element={<VenuePlanning />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/crm",
      element: (
        <PrivateRoute element={<CRM />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/addCRM",
      element: (
        <PrivateRoute element={<AddCRM />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/crm-new",
      element: (
        <PrivateRoute element={<CRMNEW />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/addLeads",
      element: (
        <PrivateRoute element={<AddLeads />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/crm-new/estimates",
      element: (
        <PrivateRoute element={<Estimates />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/crm-new/addEstimate",
      element: (
        <PrivateRoute element={<AddEstimate />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/attendees",
      element: (
        <PrivateRoute element={<Attendees />} requiredRole={[ADMIN]} />
      ),
    },
    {
      path: "/app/addAttendees",
      element: (
        <PrivateRoute element={<AddAttendee />} requiredRole={[ADMIN]} />
      ),
    },

    // {
    //   path: "/app/user-only",
    //   element: <PrivateRoute element={<UserOnly />} requiredRole={[USER]} />,
    // },
  ],
};

export default AdminRoutes;